import Icon from '@/scripts/components/basic/Icon.vue'
import Modal from '@/scripts/components/basic/Modal.vue'
import Tab from '@/scripts/components/basic/Tab.vue'
import Tabs from '@/scripts/components/basic/Tabs.vue'
import Accordion from '@/scripts/components/basic/Accordion.vue'
import AccordionGroup from '@/scripts/components/basic/AccordionGroup.vue'
import AccountSelectNav from '@/scripts/components/customers/AccountSelectNav.vue'
import CheckboxInputGroup from '@/scripts/components/forms/CheckboxInputGroup.vue'
import CustomerSelectInput from '@/scripts/components/forms/CustomerSelectInput.vue'
import CustomerTextInput from '@/scripts/components/forms/CustomerTextInput.vue'
import Toast from '@/scripts/components/basic/Toast.vue'
import Carousel from '@/scripts/components/basic/Carousel.vue'
import Slide from '@/scripts/components/basic/Slide.vue'
import ImageGrid from '@/scripts/components/basic/ImageGrid.vue'
import FullOverlay from '@/scripts/components/basic/FullOverlay.vue'
// import ScrollingText from '@/scripts/components/basic/ScrollingText.vue'

import VButton from '@/scripts/components/buttons/VButton.vue'
import VArrowButton from '@/scripts/components/buttons/VArrowButton.vue'
import VLink from '@/scripts/components/buttons/VLink.vue'
import AsyncButton from '@/scripts/components/buttons/AsyncButton.vue'

import Cart from '@/scripts/components/cart/Cart.vue'
import Sidecart from '@/scripts/components/cart/Sidecart.vue'
import Navbar from '@/scripts/components/navigation/Navbar.vue'
import FooterToTop from '@/scripts/components/navigation/FooterToTop.vue'
import PromobarCarousel from '@/scripts/components/promobar/PromobarCarousel.vue'
import SearchResults from '@/scripts/components/search/SearchResults.vue'
import ProductTile from '@/scripts/components/product/ProductTile.vue'
import ProductTileWidget from '@/scripts/components/product/ProductTileWidget.vue'
import ProductTileSkeleton from '@/scripts/components/product/ProductTileSkeleton.vue'
import ProductDisplay from '@/scripts/components/product/ProductDisplay.vue'
import Collections from '@/scripts/components/pages/Collections.vue'
// import CollectionBreadcrumbsA from '@/scripts/components/collection/CollectionBreadcrumbsA.vue'
import CollectionBreadcrumbsB from '@/scripts/components/collection/CollectionBreadcrumbsB.vue'
import CollectionHero from '@/scripts/components/collection/CollectionHero.vue'
import BlogCategoryLinks from '@/scripts/components/blog/BlogCategoryLinks.vue'
import CollectionGrid from '@/scripts/components/collection/CollectionGrid.vue'
// import VideoCarousel from '@/scripts/components/video/VideoCarousel.vue'
import VideoModal from '@/scripts/components/video/VideoModal.vue'
import About from '@/scripts/components/pages/About.vue'
import AboutImageBannerBlock from '@/scripts/components/sections/AboutImageBannerBlock.vue'
import Page404 from '@/scripts/components/pages/Page404.vue'
// import FeaturedOffersLink from '@/scripts/components/featured-offers/FeaturedOffersLink.vue';

// import KlaviyoForm from '@/scripts/components/forms/KlaviyoForm.vue'
import NewsletterSignup from '@/scripts/components/newsletter/NewsletterSignup.vue'

import FooterDefault from '@/scripts/components/footer/FooterDefault.vue'
import FooterValueProps from '@/scripts/components/footer/FooterValueProps.vue'
import FooterEmailCollection from '@/scripts/components/footer/FooterEmailCollection.vue'
import FooterMain from '@/scripts/components/footer/FooterMain.vue'
import FooterContactSocial from '@/scripts/components/footer/FooterContactSocial.vue'
import FooterSubFooter from '@/scripts/components/footer/FooterSubFooter.vue'


// UI Kit
import SelectInput from '@/scripts/components/forms/SelectInput.vue';
import TextInput from '@/scripts/components/forms/TextInput.vue';
import EmailInput from '@/scripts/components/forms/EmailInput.vue';
import TextAreaInput from '@/scripts/components/forms/TextAreaInput.vue';
import RadioInput from '@/scripts/components/forms/RadioInput.vue';

//sections
import SplitWrapper from '@/scripts/components/basic/SplitWrapper.vue';
import HeroBanner from '@/scripts/components/sections/HeroBanner.vue';
import HeroBannerText from '@/scripts/components/sections/HeroBannerText.vue';
// import HeroBannerCarousel from '@/scripts/components/sections/HeroBannerCarousel.vue';
import BlogSection from '@/scripts/components/sections/BlogSection.vue';
import FeaturedCollection from '@/scripts/components/sections/FeaturedCollection.vue';
// import CollectionLayoutTiles from '@/scripts/components/sections/CollectionLayoutTiles.vue';
// import CollectionLayoutTilesTile from '@/scripts/components/sections/CollectionLayoutTilesTile.vue';
import CollectionLayoutLinear from '@/scripts/components/sections/CollectionLayoutLinear.vue';
// import CollectionLayoutBlocks from '@/scripts/components/sections/CollectionLayoutBlocks.vue';
// import TestimonialBlocks from '@/scripts/components/sections/TestimonialBlocks.vue';
// import TestimonialCarousel from '@/scripts/components/sections/TestimonialCarousel.vue';
// import InThePress from '@/scripts/components/sections/InThePress.vue';
import Instagram from '@/scripts/components/sections/Instagram.vue';
import FiftyFifty from '@/scripts/components/sections/FiftyFifty.vue';
import FeaturedProduct from '@/scripts/components/sections/FeaturedProduct.vue';
// import ShopByPattern from '@/scripts/components/sections/ShopByPattern.vue';
// import CollectionLinks from '@/scripts/components/sections/CollectionLinks.vue';
import ProductSet from '@/scripts/components/sections/ProductSet.vue';

// import TopHeader2 from '@/scripts/components/header-2/TopHeader2.vue';
// import Header2Container from '@/scripts/components/header-2/Header2Container.vue';
// import FeaturedOffersContainer from '@/scripts/components/featured-offers/FeaturedOffersContainer.vue';
// import EditorialSets from '@/scripts/components/sections/EditorialSets.vue';

// Pages
// import PlanetboxWholesaleForm from '@/scripts/components/pages/PlanetboxWholesaleForm.vue'
import SubNav from '@/scripts/components/pages/SubNav.vue';
import FAQs from '@/scripts/components/pages/FAQs.vue';

// kit builder
// import PlanetboxKitBuilder from '@/scripts/components/pages/PlanetboxKitBuilder/PlanetboxKitBuilder.vue';

// dto
// import Header2Data from '@/scripts/components/dto/Header2Data.vue';

// Super Collections
// import SuperCollection from '@/scripts/components/pages/SuperCollection/SuperCollection.vue';
// import SuperCollectionLinear from '@/scripts/components/pages/SuperCollection/SuperCollectionLinear.vue';

/**
 * Deferred components
 *
 * These components will only load if they are rendered by markup. Use
 * for components that don't load on every page.
 *
 * i.e. below the fold components, landing page components, etc.
 */
// const AsyncComponent = () => import('scripts/components/category/AsyncComponent.vue')

export default {
  Icon,
  Modal,
  Tab,
  Tabs,
  Accordion,
  AccordionGroup,
  AccountSelectNav,
  CheckboxInputGroup,
  CustomerSelectInput,
  CustomerTextInput,
  Toast,
  Carousel,
  Slide,
  ImageGrid,
  VButton,
  VArrowButton,
  VLink,
  AsyncButton,
  Cart,
  Sidecart,
  Navbar,
  FooterToTop,
  SearchResults,
  ProductTile,
  ProductTileWidget,
  ProductTileSkeleton,
  PromobarCarousel,
  ProductDisplay,
  CollectionGrid,
  CollectionHero,
  BlogCategoryLinks,
  Collections,
  // CollectionBreadcrumbsA,
  CollectionBreadcrumbsB,
  // VideoCarousel,
  VideoModal,
  NewsletterSignup,
  // KlaviyoForm,
  About,
  AboutImageBannerBlock,
  Page404,
  FooterDefault,
  FooterValueProps,
  FooterEmailCollection,
  FooterMain,
  FooterContactSocial,
  FooterSubFooter,
  // FeaturedOffersLink,
  FullOverlay,

  // ui-kit
  SelectInput,
  TextInput,
  EmailInput,
  RadioInput,
  TextAreaInput,

  // sections
  SplitWrapper,
  HeroBanner,
  // HeroBannerText,
  // HeroBannerCarousel,
  BlogSection,
  FeaturedCollection,
  // CollectionLayoutTiles,
  // CollectionLayoutTilesTile,
  CollectionLayoutLinear,
  // CollectionLayoutBlocks,
  // TestimonialBlocks,
  // TestimonialCarousel,
  // InThePress,
  Instagram,
  FiftyFifty,
  // FeaturedProduct,
  // TopHeader2,
  // Header2Container,
  // FeaturedOffersContainer,
  // ShopByPattern,
  // EditorialSets,
  // CollectionLinks,
  ProductSet,

  // pages
  // PlanetboxWholesaleForm,
  SubNav,
  faqs: FAQs,

  // kit builder
  // PlanetboxKitBuilder,

  // super collection
  // SuperCollection,
  // SuperCollectionLinear,

  // dto
  // Header2Data,
};
